//INIT
export const INIT_SUCCESS = 'INIT_SUCCESS';
export const INIT_RESET = 'INIT_RESET';

//Auth
export const AUTH = 'AUTH';
export const DE_AUTH = 'DE_AUTH';
export const AUTH_REGISTER = 'AUTH_REGISTER';
export const AUTH_VERIFY = 'AUTH_VERIFY';
export const AUTH_GET_VERIFY = 'AUTH_GET_VERIFY';
export const AUTH_GET_RESET = 'AUTH_GET_RESET';
export const AUTH_RESET = 'AUTH_RESET';
export const AUTH_INIT = 'AUTH_INIT';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
export const UPDATE_AVATAR = 'UPDATE_AVATAR';

export const authInit = (token) => ({
    type: AUTH_INIT,
    request: {
        url: '/auth/refresh/',
        data: { token: token },
        method: 'post',
    },
});

export const register = (username, email, password) => ({
    type: AUTH_REGISTER,
    request: {
        url: '/auth/register/',
        method: 'post',
        data: {
            username: username,
            email: email,
            password: password,
        }
    }
});

export const verify = (key) => ({
    type: AUTH_VERIFY,
    request: {
        url: '/auth/verify/',
        method: 'post',
        data: {
            key: key,
        }
    }
});

export const getVerify = () => ({
    type: AUTH_GET_VERIFY,
    request: {
        url: '/auth/verify/',
    }
});

export const getReset = (email) => ({
    type: AUTH_GET_RESET,
    request: {
        url: '/auth/password/email/',
        method: 'post',
        data: {
            email: email,
        }
    }
});

export const performReset = (key, password) => ({
    type: AUTH_RESET,
    request: {
        url: '/auth/password/reset/',
        method: 'post',
        data: {
            key: key,
            new_password: password,
        }
    }
});

export const getToken = (username, password) => ({
    type: AUTH,
    request: {
        url: '/auth/token/',
        method: 'post',
        data: {
            username: username,
            password: password,
        }
    }
});

export const destroyToken = () => ({
    type: DE_AUTH,
});

export const updateProfile = (values) => ({
    type: UPDATE_PROFILE,
    request: {
        url: '/users/profile/',
        method: 'patch',
        data: values,
    }
});

export const updatePassword = (oldPassword, newPassword) => ({
    type: UPDATE_PASSWORD,
    request: {
        url: '/auth/password/',
        method: 'put',

        data: {
            oldPassword: oldPassword,
            newPassword: newPassword,
        }
    }
});

export const updateAvatar = (avatar, crop) => {
    let formData = new FormData();

    formData.append('avatar', avatar);
    formData.set('height', crop.height);
    formData.set('width', crop.width);
    formData.set('x', crop.x);
    formData.set('y', crop.y);
    return {
        type: UPDATE_AVATAR,
        request: {
            url: '/users/profile/avatar/',
            method: 'put',
            headers: {
                'Content-Type': 'multipart/form-data; boundary=---------------',
            },
            data: formData,
        }
    }
};

export const FETCH_USER = 'FETCH_USER';

export const fetchUser = (user) => ({
    type: FETCH_USER,
    request: {
        url: '/users/' + user + '/'
    }
});

// Side panels
export const PANEL_TOGGLE = 'PANEL_TOGGLE';

export const togglePanel = (panel) => ({
    type: PANEL_TOGGLE,
    panel: panel
});

// Activity Feed
export const FETCH_FEED = 'FETCH_FEED';
export const FETCH_FEED_ITEM = 'FETCH_FEED_ITEM';
export const POST_FEED = 'POST_FEED';



export const fetchFeed = (limit = 0, offset = 0) => ({
    type: FETCH_FEED,
    request: {
        url: '/feed/?limit=' + limit + '&offset=' + offset,
    },
});

export const fetchFeedItem = (item) => ({
    type: FETCH_FEED_ITEM,
    request: {
        url: '/feed/' + item + '/',
    },
});

export const postFeed = (body) => ({
    type: POST_FEED,
    request: {
        url: '/feed/posts/',
        data: { body: body },
        method: 'post',
    }
});

// News
export const FETCH_NEWS = 'FETCH_NEWS';
export const FETCH_NEWS_ITEM = 'FETCH_NEWS_ITEM';

export const fetchNews = (page = 1) => ({
    type: FETCH_NEWS,
    request: {
        url: '/news/?page=' + page,
    }
});

export const fetchNewsItem = (slug) => ({
    type: FETCH_NEWS_ITEM,
    request: {
        url: '/news/' + slug + '/',
    }
});

// Awards
export const FETCH_AWARD_SUMMARY = 'FETCH_AWARD_SUMMARY';

export const fetchAwardSummary = () => ({
    type: FETCH_AWARD_SUMMARY,
    request: {
        url: '/award-summary/'
    }
});

export const FETCH_AWARDS = 'FETCH_AWARDS';
export const FETCH_AWARD_ITEM = 'FETCH_AWARD_ITEM';
export const FETCH_USER_AWARDS = 'FETCH_USER_AWARDS';
export const FETCH_AWARD_CATEGORIES = 'FETCH_AWARD_CATEGORIES';
export const FETCH_AWARD_CATEGORY_ITEM = 'FETCH_AWARD_CATEGORY_ITEM';
export const FETCH_AWARD_RECIPIENTS = 'FETCH_AWARD_RECIPIENTS';
export const POST_AWARD_RECIPIENT = 'POST_AWARD_RECIPIENT';

export const fetchAwards = () => ({
    type: FETCH_AWARDS,
    request: {
        url: '/awards/'
    }
});

export const fetchAwardItem = (award) => ({
    type: FETCH_AWARD_ITEM,
    request: {
        url: '/awards/' + award + '/'
    }
});

export const fetchUserAwards = (user) => ({
    type: FETCH_USER_AWARDS,
    request: {
        url: '/users/' + user + '/awards/',
    }

});

export const fetchAwardCategories = () => ({
    type: FETCH_AWARD_CATEGORIES,
    request: {
        url: '/award-categories/'
    }
});

export const fetchAwardCategoryItem = (category) => ({
    type: FETCH_AWARD_CATEGORY_ITEM,
    request: {
        url: '/award-categories/' + category + '/'
    }
});

export const fetchAwardRecipients = (award, page = 1) => ({
    type: FETCH_AWARD_RECIPIENTS,
    request: {
        url: '/awards/' + award + '/recipients/?page=' + page,
    }
})

export const postAwardRecipient = (award, body) => ({
    type: POST_AWARD_RECIPIENT,
    request: {
        url: '/awards/' + award + '/recipients/',
        data: {
            reason: body.reason,
            recipient: body.member,
        },
        method: 'post',
    }
})

// Ranks

export const FETCH_RANKS = 'FETCH_RANKS';
export const FETCH_RANK_ITEM = 'FETCH_RANK_ITEM';

export const fetchRanks = () => ({
    type: FETCH_RANKS,
    request: {
        url: '/ranks/'
    }
});

export const fetchRankItem = (rank) => ({
    type: FETCH_RANK_ITEM,
    request: {
        url: '/ranks/' + rank + '/'
    }
});

//Chapters

export const FETCH_CHAPTERS = 'FETCH_CHAPTERS';
export const FETCH_CHAPTER_ITEM = 'FETCH_CHAPTER_ITEM';
export const OPEN_CHAPTER = 'OPEN_CHAPTER';
export const CLOSE_CHAPTER = 'CLOSE_CHAPTER';

export const fetchChapters = () => ({
    type: FETCH_CHAPTERS,
    request: {
        url: '/chapters/'
    }
});

export const fetchChapterItem = (chapter) => ({
    type: FETCH_CHAPTER_ITEM,
    request: {
        url: '/chapters/' + chapter + '/'
    }
});

export const openChapter = (title, launch) => ({
    type: OPEN_CHAPTER,
    request: {
        url: '/chapters/open/',
        method: 'post',
        data: {
            title: title,
            launchDate: launch
        }
    }
});

export const closeChapter = (chapter) => ({
    type: CLOSE_CHAPTER,
    request: {
        url: '/chapters/' + chapter + '/close/',
        method: 'post'
    }
});

//Divisions

export const FETCH_DIVISIONS = 'FETCH_DIVISIONS';
export const FETCH_CHAPTER_DIVISION_ITEM = 'FETCH_DIVISION_ITEM';

export const fetchDivisions = (chapter) => ({
    type: FETCH_DIVISIONS,
    request: {
        url: '/chapters/' + chapter + '/divisions/'
    }
});

export const fetchChapterDivisionItem = (chapter, division) => ({
    type: FETCH_CHAPTER_DIVISION_ITEM,
    request: {
        url: '/chapters/' + chapter + '/divisions/' + division + '/'
    }
});

// Chapter Members

export const FETCH_MEMBERSHIP_HISTORY = 'FETCH_MEMBERSHIP_HISTORY';
export const FETCH_CHAPTER_MEMBERS = 'FETCH_CHAPTER_MEMBERS';
export const FETCH_CHAPTER_MEMBER_ITEM = 'FETCH_CHAPTER_MEMBER_ITEM';

export const fetchMembershipHistory = () => ({
    type: FETCH_MEMBERSHIP_HISTORY,
    request: {
        url: '/users/profile/membership/'
    }
});

export const fetchChapterMembers = (chapter) => ({
    type: FETCH_CHAPTER_MEMBERS,
    request: {
        url: /chapters/ + chapter + '/members/',
    }
});

export const fetchChapterMemberItem = (chapter, member) => ({
    type: FETCH_CHAPTER_MEMBER_ITEM,
    request: {
        url: /chapters/ + chapter + '/members/' + member + '/',
    }
});

//Applications

export const FETCH_APPLICATION = 'FETCH_APPLICATION';
export const FETCH_USER_APPLICATIONS = 'FETCH_USER_APPLICATIONS';
export const FETCH_APPLICATION_QUESTIONS = 'FETCH_APPLICATION_QUESTIONS';
export const FETCH_ACTIVE_APPLICATIONS = 'FETCH_ACTIVE_APPLICATIONS';
export const FETCH_ARCHIVED_APPLICATIONS = 'FETCH_ARCHIVED_APPLICATIONS';
export const FETCH_APPLICATION_INTERESTS = 'FETCH_APPLICATION_INTERESTS';
export const POST_STEPONE_APPLICATION = 'POST_STEPONE_APPLICATION';
export const POST_STEPONE_REDO_APPLICATION = 'POST_STEPONE_REDO_APPLICATION';
export const POST_STEPTWO_APPLICATION = 'POST_STEPTWO_APPLICATION';
export const POST_STEPTWO_REDO_APPLICATION = 'POST_STEPTWO_REDO_APPLICATION';
export const POST_ESCALATE_APPLICATION = 'POST_ESCALATE_APPLICATION';
export const POST_REDO_APPLICATION = 'POST_REDO_APPLICATION';
export const POST_ACCEPT_APPLICATION = 'POST_ACCEPT_APPLICATION';
export const POST_REJECT_APPLICATION = 'POST_REJECT_APPLICATION';
export const POST_CLOSE_APPLICATION = 'POST_CLOSE_APPLICATION';

export const fetchActiveApplications = () => ({
    type: FETCH_ACTIVE_APPLICATIONS,
    request: {
        url: '/applications/'
    }
});

export const fetchArchivedApplications = () => ({
    type: FETCH_ARCHIVED_APPLICATIONS,
    request: {
        url: '/applications/archive/'
    }
});

export const fetchApplication = (id) => ({
    type: FETCH_APPLICATION,
    request: {
        url: '/applications/' + id + '/',
    }
});

export const fetchUserApplications = (user) => ({
    type: FETCH_USER_APPLICATIONS,
    request: {
        url: '/users/' + user + '/applications/',
    }
});

export const fetchApplicationQuestions = (chapter) => ({
    type: FETCH_APPLICATION_QUESTIONS,
    request: {
        url: '/chapters/' + chapter + '/questions/'
    }
});

export const fetchApplicationInterests = () => ({
    type: FETCH_APPLICATION_INTERESTS,
    request: {
        url: 'applications/interests/'
    }
});

export const applyStepOne = (app) => ({
    type: POST_STEPONE_APPLICATION,
    request: {
        url: '/applications/',
        method: 'post',
        data: {
            name: app.name,
            gender: app.gender,
            birthdate: app.birthdate,
            location: app.location,
            discord: app.discord,
            characterName: app.characterName,
            characterClass: app.characterClass,
            characterLevel: app.characterLevel,
            technicalSkills: app.technicalSkills,
            playtime: app.playtime,
            gameDetailedHistory: app.gameDetailedHistory,
            playerType: app.playerType,
            whyJoin: app.whyJoin,
            chapter: app.chapter,
        }
    }
});

export const redoStepOne = (app, appId) => ({
    type: POST_STEPONE_REDO_APPLICATION,
    request: {
        url: '/applications/' + appId + '/',
        method: 'put',
        data: {
            name: app.name,
            gender: app.gender,
            birthdate: app.birthdate,
            location: app.location,
            discord: app.discord,
            characterName: app.characterName,
            characterClass: app.characterClass,
            characterLevel: app.characterLevel,
            technicalSkills: app.technicalSkills,
            playtime: app.playtime,
            gameDetailedHistory: app.gameDetailedHistory,
            playerType: app.playerType,
            whyJoin: app.whyJoin,
            chapter: app.chapter,
        }
    }
});

export const applyStepTwo = (app, appId) => ({
    type: POST_STEPTWO_APPLICATION,
    request: {
        url: '/applications/' + appId + '/',
        method: 'post',
        data: app
    }
});

export const redoStepTwo = (app, appId) => ({
    type: POST_STEPTWO_REDO_APPLICATION,
    request: {
        url: '/applications/' + appId + '/',
        method: 'put',
        data: app
    }
});

export const applicationEscalate = (reason, appId) => ({
    type: POST_ESCALATE_APPLICATION,
    request: {
        url: '/applications/' + appId + '/escalate/',
        method: 'post',
        data: {
            reason: reason
        }
    }
});

export const applicationRedo = (reason, appId) => ({
    type: POST_REDO_APPLICATION,
    request: {
        url: '/applications/' + appId + '/redo/',
        method: 'post',
        data: {
            reason: reason
        }
    }
});

export const applicationAccept = (reason, appId) => ({
    type: POST_ACCEPT_APPLICATION,
    request: {
        url: '/applications/' + appId + '/accept/',
        method: 'post',
        data: {
            reason: reason
        }
    }
});

export const applicationReject = (reason, appId) => ({
    type: POST_REJECT_APPLICATION,
    request: {
        url: '/applications/' + appId + '/reject/',
        method: 'post',
        data: {
            reason: reason
        }
    }
});

export const applicationClose = (reason, appId) => ({
    type: POST_CLOSE_APPLICATION,
    request: {
        url: '/applications/' + appId + '/close/',
        method: 'post',
        data: {
            reason: reason
        }
    }
});

//Notifications

export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS';
export const FETCH_NOTIFICATION_ITEM = 'FETCH_NOTIFICATION_ITEM';

export const fetchNotifications = () => ({
    type: FETCH_NOTIFICATIONS,
    request: {
        url: '/notifications/'
    }
});

export const fetchNotificationItem = (notification) => ({
    type: FETCH_NOTIFICATION_ITEM,
    request: {
        url: '/notifications/' + notification + '/'
    }
});


export const NOTIFICATION_ISREAD = 'NOTIFICATION_ISREAD';
export const updateNotificationIsRead = (id) => ({
    type: NOTIFICATION_ISREAD,
    request: {
        url: '/notifications/' + id + '/',
        method: 'patch',
        data: {
            isRead: true,
        }
    }
});


// Websocket Actions

export const SEND_LOCATION = 'SEND_LOCATION';

export const postLocation = (location) => ({
    type: SEND_LOCATION,
    location: location,
});

// Comment Actions

export const POST_COMMENT = 'POST_COMMENT';
export const FETCH_COMMENTS = 'FETCH_COMMENTS';

export const postComment = (comment, api, security) => ({
    type: POST_COMMENT,
    request: {
        url: api + '/comments/',
        method: 'post',
        data: {
            body: comment,
            restrictionLevel: security,
        },
    }
});

export const fetchComments = (item) => ({
    type: FETCH_COMMENTS,
    request: {
        url: item + '/comments/',
    }
});

// Media Actions

// Quote Actions

export const FETCH_QUOTES = 'FETCH_QUOTES';
export const FETCH_QUOTE_ITEM = 'FETCH_QUOTE_ITEM';
export const POST_QUOTE = 'POST_QUOTE';

export const fetchQuotes = (page = 1) => ({
    type: FETCH_QUOTES,
    request: {
        url: '/quotes/?page=' + page,
    }
});

export const fetchQuoteItem = (item) => ({
    type: FETCH_QUOTE_ITEM,
    request: {
        url: '/quotes/' + item + '/',
    }
});

export const postQuote = (quote) => ({
    type: POST_QUOTE,
    request: {
        url: '/quotes/',
        method: 'post',
        data: {
            body: quote,
        },
    }
});

// Codex Actions

export const FETCH_CODEX = 'FETCH_CODEX';
export const FETCH_CODEX_ITEM = 'FETCH_CODEX_ITEM';
export const POST_CODEX = 'POST_CODEX';
export const UPDATE_CODEX = 'UPDATE_CODEX';
export const DELETE_CODEX = 'DELETE_CODEX';

export const fetchCodex = () => ({
    type: FETCH_CODEX,
    request: {
        url: '/codex/',
    }
});

export const fetchCodexItem = (codex) => ({
    type: FETCH_CODEX_ITEM,
    request: {
        url: '/codex/' + codex + '/',
    }
});

export const createCodex = (values) => ({
    type: POST_CODEX,
    request: {
        url: '/codex/',
        method: 'post',
        data: {
            title: values.title,
            body: values.codex,
            order: values.order,
            restrictionLevel: values.restrictionLevel,
            parent: values.parent === "None" ? null : values.parent
        },
    }
});

export const updateCodex = (codex, values) => ({
    type: UPDATE_CODEX,
    request: {
        url: '/codex/' + codex + '/',
        method: 'put',
        data: {
            title: values.title,
            body: values.codex,
            order: values.order,
            restrictionLevel: values.restrictionLevel,
            parent: values.parent === "None" ? null : values.parent
        },
    }
});



export const FETCH_DKP_SECTIONS = 'FETCH_DKP_SECTIONS';
export const FETCH_DKP_SECTION_ITEM = 'FETCH_DKP_SECTION_ITEM';
export const FETCH_DKP_SECTION_STANDINGS = 'FETCH_DKP_SECTION_STANDINGS';
export const FETCH_DKP_SECTION_STANDING_ITEM = 'FETCH_DKP_SECTION_STANDING_ITEM';


export const fetchSections = (chapter) => ({
    type: FETCH_DKP_SECTIONS,
    request: {
        url: '/chapters/' + chapter + '/dkp/'
    }
});

export const fetchUserSections = (user) => ({
    type: FETCH_DKP_SECTIONS,
    request: {
        url: '/users/' + user + '/dkp/'
    }
});

export const fetchSectionItem = (chapter, section) => ({
    type: FETCH_DKP_SECTION_ITEM,
    request: {
        url: '/chapters/' + chapter + '/dkp/' + section + '/'
    }
});

export const fetchSectionStandings = (chapter, section) => ({
    type: FETCH_DKP_SECTION_STANDINGS,
    request: {
        url: '/chapters/' + chapter + '/dkp/' + section + '/standings/'
    }
});

export const fetchSectionStandingItem = (chapter, section, standing) => ({
    type: FETCH_DKP_SECTION_STANDING_ITEM,
    request: {
        url: '/chapters/' + chapter + '/dkp/' + section + '/standings/' + standing + '/'
    }
});


export const FETCH_DKP_EVENTS = 'FETCH_DKP_EVENTS';
export const FETCH_DKP_USER_EVENTS = 'FETCH_DKP_USER_EVENTS';
export const FETCH_DKP_RECENT_EVENTS = 'FETCH_DKP_RECENT_EVENTS';
export const FETCH_DKP_ACTIVE_EVENTS = 'FETCH_DKP_ACTIVE_EVENTS';
export const FETCH_DKP_EVENT_ITEM = 'FETCH_DKP_EVENT_ITEM';
export const POST_DKP_EVENT = 'POST_DKP_EVENT';

export const fetchEvents = (chapter, section, page = 1) => ({
    type: FETCH_DKP_EVENTS,
    request: {
        url: '/chapters/' + chapter + '/dkp/' + section + '/events/?page=' + page
    }
});

export const fetchUserEvents = (user, section) => ({
    type: FETCH_DKP_USER_EVENTS,
    request: {
        url: '/users/' + user + '/dkp/' + section + '/events/'
    }
});


export const fetchEventItem = (item, chapter = 0, section = 0) => ({
    type: FETCH_DKP_EVENT_ITEM,
    request: {
        url: '/chapters/' + chapter + '/dkp/' + section + '/events/' + item + '/'
    }
});

export const fetchRecentEvents = (chapter, section) => ({
    type: FETCH_DKP_RECENT_EVENTS,
    request: {
        url: '/chapters/' + chapter + '/dkp/' + section + '/recent-events/'
    }
});
export const fetchActiveEvents = (chapter, section) => ({
    type: FETCH_DKP_ACTIVE_EVENTS,
    request: {
        url: '/chapters/' + chapter + '/dkp/' + section + '/active-events/'
    }
});

export const postEvent = (chapter, section, event) => ({
    type: POST_DKP_EVENT,
    request: {
        url: '/chapters/' + chapter + '/dkp/' + section + '/events/',
        method: 'post',
        data: {
            eventLeader: event.eventLeader,
            location: event.location,
            section: event.section,
            title: event.title,
            dkp: event.dkp,
            scheduled: event.scheduled,
            standbyRate: event.standbyRate ? event.standbyRate : 0.5,
            standbyEntities: event.standbyEntities ? event.standbyEntities : false,
            copy: event.copy
        },
    }
});

export const startEvent = (chapter, section, event) => ({
    type: POST_DKP_EVENT,
    request: {
        url: '/chapters/' + chapter + '/dkp/' + section + '/events/' + event + '/start/',
        method: 'post',
    }
});

export const stopEvent = (chapter, section, event, stopTime = null) => ({
    type: POST_DKP_EVENT,
    request: {
        url: '/chapters/' + chapter + '/dkp/' + section + '/events/' + event + '/stop/',
        method: 'post',
        data: {
            stopped: stopTime,
        }
    }
});

export const restartEvent = (chapter, section, event) => ({
    type: POST_DKP_EVENT,
    request: {
        url: '/chapters/' + chapter + '/dkp/' + section + '/events/' + event + '/restart/',
        method: 'post',
    }
});

export const POST_DKP_ATTENDANCE = 'POST_DKP_ATTENDANCE';
export const UPDATE_DKP_ATTENDANCE = 'UPDATE_DKP_ATTENDANCE';
export const DELETE_DKP_ATTENDANCE = 'DELETE_DKP_ATTENDANCE';

export const postAttendance = (chapter = 0, section = 0, event, attendee) => ({
    type: POST_DKP_ATTENDANCE,
    request: {
        url: '/chapters/' + chapter + '/dkp/' + section + '/events/' + event + '/attendance/',
        method: 'post',
        data: {
            user: attendee.user.id,
            standby: attendee.standby ? true : false
        },
    }
});

export const updateAttendance = (chapter = 0, section = 0, event, attendee) => ({
    type: UPDATE_DKP_ATTENDANCE,
    request: {
        url: '/chapters/' + chapter + '/dkp/' + section + '/events/' + event + '/attendance/' + attendee.id + '/',
        method: 'put',
        data: {
            user: attendee.user,
            started: attendee.started,
            stopped: attendee.stopped ? attendee.stopped : null
        },
    }
});

export const deleteAttendance = (chapter = 0, section = 0, event, attendee) => ({
    type: DELETE_DKP_ATTENDANCE,
    request: {
        url: '/chapters/' + chapter + '/dkp/' + section + '/events/' + event + '/attendance/' + attendee.id + '/',
        method: 'delete',
    }
});

export const POST_DKP_ENTITY = "POST_DKP_ENTITY";
export const UPDATE_DKP_ENTITY = "UPDATE_DKP_ENTITY";
export const DELETE_DKP_ENTITY = "DELETE_DKP_ENTITY";

export const postEntity = (chapter = 0, section = 0, event, entity) => ({
    type: POST_DKP_ENTITY,
    request: {
        url: '/chapters/' + chapter + '/dkp/' + section + '/events/' + event + '/entities/',
        method: 'post',
        data: {
            entity: entity.eventEntity,
            dkp: entity.dkp
        },
    }
});

export const updateEntity = (chapter = 0, section = 0, event, entity) => ({
    type: UPDATE_DKP_ENTITY,
    request: {
        url: '/chapters/' + chapter + '/dkp/' + section + '/events/' + event + '/entities/' + entity.id + '/',
        method: 'put',
        data: {
            entity: entity.eventEntity,
            dkp: entity.dkp
        },
    }
});

export const deleteEntity = (chapter = 0, section = 0, event, entity) => ({
    type: DELETE_DKP_ENTITY,
    request: {
        url: '/chapters/' + chapter + '/dkp/' + section + '/events/' + event + '/entities/' + entity.id + '/',
        method: 'delete',

    }
});

export const POST_DKP_ITEM = "POST_DKP_ITEM";
export const UPDATE_DKP_ITEM = "UPDATE_DKP_ITEM";
export const DELETE_DKP_ITEM = "DELETE_DKP_ITEM";

export const postItem = (chapter = 0, section = 0, event, item) => ({
    type: POST_DKP_ITEM,
    request: {
        url: '/chapters/' + chapter + '/dkp/' + section + '/events/' + event + '/items/',
        method: 'post',
        data: {
            item: item.eventItem,
            user: item.member,
            dkp: item.dkp
        },
    }
});

export const updateItem = (chapter = 0, section = 0, event, item) => ({
    type: UPDATE_DKP_ITEM,
    request: {
        url: '/chapters/' + chapter + '/dkp/' + section + '/events/' + event + '/items/' + item.id + '/',
        method: 'put',
        data: {
            item: item.eventItem,
            user: item.member,
            dkp: item.dkp
        },
    }
});

export const deleteItem = (chapter = 0, section = 0, event, item) => ({
    type: DELETE_DKP_ITEM,
    request: {
        url: '/chapters/' + chapter + '/dkp/' + section + '/events/' + event + '/items/' + item.id + '/',
        method: 'delete',

    }
});

export const FETCH_DKP_ITEMS = 'FETCH_DKP_ITEMS';
export const FETCH_DKP_ITEM_HISTORY = 'FETCH_DKP_ITEM_HISTORY';
export const FETCH_DKP_ITEM_DETAIL = 'FETCH_DKP_ITEM_DETAIL';

export const fetchItems = (chapter, page = 1) => ({
    type: FETCH_DKP_ITEMS,
    request: {
        url: '/chapters/' + chapter + '/items/?page=' + page
    }
});

export const fetchItemHistory = (item) => ({
    type: FETCH_DKP_ITEM_HISTORY,
    request: {
        url: '/dkp/items/' + item + '/'
    }
});

export const FETCH_DKP_LOCATIONS = 'FETCH_DKP_LOCATIONS';
export const FETCH_DKP_LOCATION_ITEM = 'FETCH_DKP_LOCATION_ITEM';
export const POST_DKP_LOCATION = 'POST_DKP_LOCATION';
export const UPDATE_DKP_LOCATION = 'UPDATE_DKP_LOCATION';
export const DELETE_DKP_LOCATION = 'DELETE_DKP_LOCATION';

export const fetchLocations = (chapter) => ({
    type: FETCH_DKP_LOCATIONS,
    request: {
        url: '/chapters/' + chapter + '/locations/'
    }
});

export const fetchLocationItem = (chapter, location) => ({
    type: FETCH_DKP_LOCATIONS,
    request: {
        url: '/chapters/' + chapter + '/locations/' + location + '/'
    }
});

// postLocation already used for socket
export const createLocation = (chapter, data) => ({
    type: POST_DKP_LOCATION,
    request: {
        url: '/chapters/' + chapter + '/locations/',
        method: 'post',
        data: {
            title: data.title,
            description: data.description ? data.description : '',
            dkp: data.dkp,
        }
    }
});

export const updateLocation = (chapter, location, data) => ({
    type: UPDATE_DKP_LOCATION,
    request: {
        url: '/chapters/' + chapter + '/locations/' + location + '/',
        method: 'put',
        data: {
            title: data.title,
            description: data.description ? data.description : '',
            dkp: data.dkp,
        }
    }
});

export const deleteLocation = (chapter, location) => ({
    type: DELETE_DKP_LOCATION,
    request: {
        url: '/chapters/' + chapter + '/locations/' + location + '/',
        method: 'delete',
    }
});

export const FETCH_DKP_RESOURCES = 'FETCH_DKP_RESOURCES';
export const FETCH_DKP_RESOURCE_ITEM = 'FETCH_DKP_RESOURCE_ITEM';
export const POST_DKP_RESOURCE = 'POST_DKP_RESOURCE';
export const UPDATE_DKP_RESOURCE = 'UPDATE_DKP_RESOURCE';
export const DELETE_DKP_RESOURCE = 'DELETE_DKP_RESOURCE';

export const fetchResources = (chapter, section) => ({
    type: FETCH_DKP_RESOURCES,
    request: {
        url: '/chapters/' + chapter + '/dkp/' + section + '/resources/'
    }
});

export const fetchResourceItem = (chapter, section, resource) => ({
    type: FETCH_DKP_RESOURCE_ITEM,
    request: {
        url: '/chapters/' + chapter + '/dkp/' + section + '/resources/' + resource + '/'
    }
});

export const createResource = (chapter, section, data) => ({
    type: POST_DKP_RESOURCE,
    request: {
        url: '/chapters/' + chapter + '/dkp/' + section + '/resources/',
        method: 'post',
        data: {
            title: data.title,
            dkp: data.dkp,
            amount: data.amount,
            category: data.category,
        }
    }
});

export const updateResource = (chapter, section, resource, data) => ({
    type: UPDATE_DKP_RESOURCE,
    request: {
        url: '/chapters/' + chapter + '/dkp/' + section + '/resources/' + resource + '/',
        method: 'put',
        data: {
            title: data.title,
            dkp: data.dkp,
            amount: data.amount,
            category: data.category,
        }
    }
});

export const deleteResource = (chapter, section, resource) => ({
    type: DELETE_DKP_RESOURCE,
    request: {
        url: '/chapters/' + chapter + '/dkp/' + section + '/resources/' + resource + '/',
        method: 'delete',
    }
});

export const FETCH_DKP_RESOURCE_CONTRIBUTIONS = 'FETCH_DKP_RESOURCE_CONTRIBUTION';
export const FETCH_DKP_RESOURCE_CONTRIBUTION_ITEM = 'FETCH_DKP_RESOURCE_CONTRIBUTION_ITEM';
export const POST_DKP_RESOURCE_CONTRIBUTION = 'POST_DKP_RESOURCE_CONTRIBUTION';
export const UPDATE_DKP_RESOURCE_CONTRIBUTION = 'UPDATE_DKP_RESOURCE_CONTRIBUTION';
export const DELETE_DKP_RESOURCE_CONTRIBUTION = 'DELETE_DKP_RESOURCE_CONTRIBUTION';

export const createResourceContribution = (chapter, section, resource, data) => ({
    type: POST_DKP_RESOURCE_CONTRIBUTION,
    request: {
        url: '/chapters/' + chapter + '/dkp/' + section + '/resources/' + resource + '/contributions/',
        method: 'post',
        data: {
            user: data.user.slug,
            dkp: data.dkp,
            amount: data.amount,
            description: data.description ? data.description : null
        }
    }
});

export const fetchResourceContributions = (chapter, section, resource) => ({
    type: FETCH_DKP_RESOURCE_CONTRIBUTIONS,
    request: {
        url: '/chapters/' + chapter + '/dkp/' + section + '/resources/' + resource + '/contributions/'
    }
});

export const fetchResourceContributionItem = (chapter, section, resource, contribution) => ({
    type: FETCH_DKP_RESOURCE_CONTRIBUTION_ITEM,
    request: {
        url: '/chapters/' + chapter + '/dkp/' + section + '/resources/' + resource + '/contributions/' + contribution + '/'
    }
});


export const updateResourceContribution = (chapter, section, resource, contribution, data) => ({
    type: UPDATE_DKP_RESOURCE_CONTRIBUTION,
    request: {
        url: '/chapters/' + chapter + '/dkp/' + section + '/resources/' + resource + '/contributions/' + contribution + '/',
        method: 'put',
        data: {
            user: data.user.slug,
            dkp: data.dkp,
            amount: data.amount,
        }
    }
});

export const deleteResourceContribution = (chapter, section, resource, contribution) => ({
    type: DELETE_DKP_RESOURCE_CONTRIBUTION,
    request: {
        url: '/chapters/' + chapter + '/dkp/' + section + '/resources/' + resource + '/contributions/' + contribution + '/',
        method: 'delete',
    }
});


export const FETCH_DKP_ENTITIES = 'FETCH_DKP_ENTITIES';
export const FETCH_DKP_ENTITY_ITEM = 'FETCH_DKP_ENTITY_ITEM';

export const fetchEntities = (chapter, location) => ({
    type: FETCH_DKP_ENTITIES,
    request: {
        url: '/chapters/' + chapter + '/locations/' + location + '/entities/'
    }
});

export const fetchEntityItem = (chapter, location, entity) => ({
    type: FETCH_DKP_ENTITY_ITEM,
    request: {
        url: '/chapters/' + chapter + '/locations/' + location + '/entities/' + entity + '/'
    }
});

export const FETCH_POLLS = 'FETCH_POLLS';
export const POST_POLL = 'POST_POLL';
export const POST_VOTE = 'POST_VOTE';

export const fetchPolls = (user) => ({
    type: FETCH_POLLS,
    request: {
        url: '/users/' + user.slug + '/polls/',
    }
})

export const postPoll = (user, data) => ({
    type: POST_POLL,
    request: {
        url: '/users/' + user.slug + '/polls/',
        data: {
            title: data,
        },
        method: 'post',
    }
})

export const postVote = (poll, item) => ({
    type: POST_VOTE,
    request: {
        url: '/polls/' + poll.slug + '/choices/' + item.id + '/votes/',
        method: 'post',
    },
})

export const FETCH_SCREENSHOTS = 'FETCH_SCREENSHOTS'
export const FETCH_SCREENSHOT_ITEM = 'FETCH_SCREENSHOT_ITEM'
export const POST_SCREENSHOT = 'POST_SCREENSHOT'

export const fetchScreenshots = (page) => ({
    type: FETCH_SCREENSHOTS,
    request: {
        url: '/screenshots/?page=' + page,
    }
})

export const fetchScreenshotItem = (screenshot) => ({
    type: FETCH_SCREENSHOT_ITEM,
    request: {
        url: '/screenshots/' + screenshot + '/',
    }
})

export const postScreenshot = (data) => {

    let formData = new FormData();

    formData.append('image', data.image);
    formData.set('title', data.title);
    formData.set('chapter', data.chapter);
    formData.set('involved', data.involved)

    return {
        type: POST_SCREENSHOT,
        request: {
            url: '/screenshots/',
            method: 'post',
            headers: {
                'Content-Type': 'multipart/form-data; boundary=---------------',
            },
            data: formData,
        }
    }
};


export const SOCKET_ONLINE_USERS = 'SOCKET_ONLINE_USERS';
export const SOCKET_USER = 'SOCKET_USER';
export const SOCKET_FEED = 'SOCKET_FEED';
export const SOCKET_NEWS = 'SOCKET_NEWS';
export const SOCKET_APPLICATION = 'SOCKET_APPLICATION';
export const SOCKET_CHAPTER = 'SOCKET_CHAPTER';
export const SOCKET_CHAPTER_MEMBER = 'SOCKET_CHAPTER_MEMBER';
export const SOCKET_CHAPTER_DIVISION = 'SOCKET_CHAPTER_DIVISION';
export const SOCKET_RANK = 'SOCKET_RANK';
export const SOCKET_AWARD = 'SOCKET_AWARD';
export const SOCKET_AWARD_CATEGORY = 'SOCKET_AWARD_CATEGORY';
export const SOCKET_NOTIFICATION = 'SOCKET_NOTIFICATION';
export const SOCKET_DKP_EVENT = 'SOCKET_DKP_EVENT';
export const SOCKET_DKP_STANDINGS = 'SOCKET_DKP_STANDINGS';
export const SOCKET_DKP_RESOURCE = 'SOCKET_DKP_RESOURCE';
export const SOCKET_DKP_RESOURCE_CONTRIBUTION = 'SOCKET_DKP_RESOURCE_CONTRIBUTION';
export const SOCKET_AWARD_RECIPIENT = 'SOCKET_AWARD_RECIPIENT';
export const SOCKET_POLL = 'SOCKET_POLL';
export const SOCKET_SCREENSHOT = 'SOCKET_SCREENSHOT';
export const SOCKET_QUOTE = 'SOCKET_QUOTE';
export const SOCKET_CODEX = 'SOCKET_CODEX';



// WEBPACK FOOTER //
// ./src/redux/actions.js